export const BASE_LAYERS_EXPLORER = {
  STILES: 'stiles',
  DARK: 'dark',
  LIGHT: 'light',
};

export const OVERLAYS = {
  ...BASE_LAYERS_EXPLORER,
  LABELS: 'labels',
  CENTER_MARKER: 'centerMarker',
};
